import React from 'react'
import Banner from "./banner"
import Clients from "./clients"
import NewArrivals from "./new-arrivals"
import BestSellerProducts from "./best-seller-products"
import ProductDetails from "./product-details"
import TopRatedProducts from "./top-rated-product"
import { useGetBrandStatusQuery } from "../../../services/homeAPI"
import { Helmet } from 'react-helmet';

function Home() {
  const { data: brandsStatus } = useGetBrandStatusQuery();

  return (
    <>
      <Helmet>
        <title>Launch Your Online Store with a Powerful E-Commerce Website Builder</title>
        <meta name="description" content="Create fast, secure, and mobile-optimized e-commerce websites with ease. Ideal for small and medium businesses looking to grow their online presence." />
      </Helmet>
      <div>
        <Banner />
        {brandsStatus?.data?.is_active === 1 ? <Clients /> : null}
        <NewArrivals />
        <BestSellerProducts />
        <ProductDetails />
        <TopRatedProducts />
      </div>
    </>

  )
}

export default Home